import { render } from "./UserCenterOrder.vue?vue&type=template&id=876cdc34&scoped=true"
import script from "./UserCenterOrder.vue?vue&type=script&lang=js"
export * from "./UserCenterOrder.vue?vue&type=script&lang=js"

import "./UserCenterOrder.vue?vue&type=style&index=0&id=876cdc34&lang=scss&scoped=true"

import exportComponent from "D:\\work\\code\\tranWorld\\traneasy-reply(易回复官网)\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-876cdc34"]])

export default __exports__